<div class="d-flex">
  <div class="document-buttons">
    <div id="btn-general" class="document-button general selected">
      <button type="submit" class="btn-documents">
        <i class="icon-user"></i>
        {{ "forms.buttons.new" | translate }}
      </button>
    </div>
  </div>

  <div class="card w-100 form-right">

    <div class="back">
      <div class="div-title">
        <h2 class="">
          {{ "forms.names.createAssignee" | translate }}
        </h2>
      </div>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>

    <div class="card-body" [ngSwitch]="step">
      <form [formGroup]="assigneeForm" (ngSubmit)="onSubmitAssignee()">
        <div class="form-section mb-3" *ngSwitchCase="1">

          <div class="row" *ngIf="showAlertFilter">
            <div class="col-12">
              <div class="" role="alert">
                <div *ngIf="taxIdExists" class="alert alert-warning mt-2">
                  {{ "inputs.tax_id_duplicated" | translate }} <a class="redirect-tax-id"
                    (click)="onDuplicateFound()">aquí</a>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="mb-3">
                <label for="tax_id" class="form-label">
                  {{ "inputs.tax_id" | translate }} <span class="required">*</span>
                </label>
                <input id="tax_id" class="form-control" formControlName="tax_id"
                  placeholder="{{ 'inputs.tax_id' | translate }}" (input)="onTaxIdChange()" />
              </div>
            </div>
          </div>

          <div *ngIf="!showAdditionalFields">
            <div class="divider-container">
              <hr class="divider-line" />
              <span class="divider-text">{{ "inputs.or_if_you_prefer" | translate }}</span>
              <hr class="divider-line" />
            </div>

            <div>
              <div *ngIf="uploadFile">
                <div class="form-section">
                  <span>{{ "forms.labels.create_client_with_documents" | translate }}</span>

                  <div class="drop-zone" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
                    {{ "forms.labels.draganddrop" | translate }}
                    <input #fileInput type="file" multiple class="input-file-hidden" (change)="onFileInputChange($event)" />
                  </div>
                </div>

                <ul *ngIf="files.length > 0">
                  <li *ngFor="let file of files; let i = index">
                    <div class="listFiles">
                      <div class="div-thumbnail">
                        <img class="thumbnail" [src]="getThumbnailSrc(file.file)" alt="Thumbnail" />
                        {{ file.file.name }}
                        <span (click)="removeFile(i)">
                          <i class="icon-trash"></i>
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Botones para continuar -->
          <div *ngIf="canProceed && !showAdditionalFields" class="button-container">
            <button class="btn btn-primary" (click)="onNextStep()" [disabled]="taxIdExists"> {{"buttons.next_step" |
              translate }}</button>
          </div>

        </div>

        <!-- Segundo paso: Formulario con los campos existentes -->
        <div *ngIf="showAdditionalFields">
          <div class="form-section mb-3 pb-3">

            <div class="row mb-2">
              <div class="col-12">
                <div class="mb-3">
                  <label for="type" class="form-label">{{ "inputs.type" | translate }}
                    <span class="required">*</span>
                  </label>
                  <div class="position-relative">
                    <select id="type" class="form-control" formControlName="type">
                      <option value="" disabled selected>{{ "inputs.type" | translate }}</option>
                      <option value="individual">{{ "inputs.individual" | translate }}</option>
                      <option value="self-employed">{{ "inputs.employee" | translate }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row linea"></div>


            <div class="mb-3">
              <div class="row">
                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="vendor" class="form-label">{{ "inputs.name" | translate }}
                      <span class="required">*</span>
                    </label>
                    <input id="vendor" class="form-control" formControlName="name"
                      placeholder="  {{ 'inputs.name' | translate }}" />
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="supplier" class="form-label">{{ "inputs.lastname" | translate }}</label>
                    <input id="lastname" class="form-control" formControlName="lastname"
                      placeholder=' {{ "inputs.lastname" | translate }}' />
                  </div>
                </div>
              </div>
            </div>

            <div class="row linea"></div>

            <div class="row mb-2">
              <div class="col-12">
                <div class="mb-3">
                  <label for="birth_date" class="form-label">
                    {{ "inputs.birth_date" | translate }}
                  </label>
                  <div class="calendar-container">
                    <mat-form-field appearance="fill" class="calendar-main">
                      <input matInput [matDatepicker]="birthDatepicker" formControlName="birth_date"
                        placeholder="{{ 'inputs.birth_date' | translate }}" (dateChange)="onDateChange($event)"
                        [min]="minDate" [max]="maxDate">
                      <mat-datepicker-toggle matSuffix [for]="birthDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #birthDatepicker></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="assigneeForm.hasError('birthDateRequired') && assigneeForm.touched">
                      <small class="text-danger">
                        La fecha de nacimiento es requerida
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-5 col-xl-4">
                  <div class="mb-3">
                    <label for="vendor" class="form-label">{{ "inputs.birthplace_country" | translate }}
                    </label>
                    <app-select-country-prefix [showPhonePrefix]="false" [selectionMode]="'name'"
                      [selectedCountryName]="assigneeForm.get('birthplace_country')?.value"
                      (changeBirthplace)="changeBirthplace($event)"
                      (countrySelected)="onBirthplaceCountrySelected($event)">
                    </app-select-country-prefix>
                  </div>
                </div>
                <div class="col-7 col-xl-8">
                  <div class="mb-3">
                    <label for="supplier" class="form-label">{{ "inputs.nationality" | translate }}</label>
                    <input id="lastname" class="form-control" formControlName="nationality"
                      placeholder=' {{ "inputs.nationality" | translate }}' />
                  </div>
                </div>
              </div>
            </div>


            <div class="row linea"></div>
            <div class="row mb-2">
              <div class="col-12">
                <div class="mb-3 ">
                  <label for="birth_date" class="form-label">{{'inputs.tax_id_expiration_date' | translate }}
                  </label>
                  <div class="calendar-container">
                    <mat-form-field appearance="fill" class="calendar-main">
                      <input matInput [matDatepicker]="expirationDatepicker" formControlName="document_expiration_date"
                        placeholder="{{'inputs.tax_id_expiration_date' | translate }}" (dateChange)="onDateChange2($event)"
                        [min]="minDate" [max]="maxDateExpiration">

                      <mat-datepicker-toggle matSuffix [for]="expirationDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #expirationDatepicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="row linea"></div>
            <div class="row mb-2">
              <div class="col-12">
                <div class="mb-3">
                  <label for="supplier" class="form-label">{{ "inputs.email" | translate }}
                    <span class="required">*</span></label>
                  <input id="email" class="form-control" formControlName="email"
                    placeholder=' {{ "inputs.email" | translate }}' />
                </div>
                <div *ngIf="isFieldInvalid('email')">
                  <small *ngIf="getFormError('email', 'required')" class="error_validation">El correo es
                    obligatorio.</small>
                  <small *ngIf="getFormError('email', 'email')" class="error_validation">El formato del correo es
                    inválido.</small>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4">
                <div class="mb-3">
                  <label for="phone_prefix" class="form-label">{{ "inputs.phone_prefix" | translate }}
                    <span class="required">*</span>
                  </label>
                  <app-select-country-prefix (changePrefix)="changePrefix($event)"
                    [selectedPrefix]="assigneeForm.get('phonePrefix')?.value"
                    [selectionMode]="'prefix'"></app-select-country-prefix>
                </div>
              </div>

              <div class="col-8">
                <div class="mb-3">
                  <label for="phone" class="form-label">{{ "inputs.phone" | translate }}
                    <span class="required">*</span>
                  </label>
                  <div class="input-group">
                    <input id="phone" class="form-control phone-number" formControlName="phoneNumber" type="tel"
                      placeholder="{{ 'inputs.phone' | translate }}" (input)="onInput($event)" />
                    <button
                      *ngIf="canUseVoip"
                      class="btn btn-outline-success"
                      type="button"
                      [disabled]="!assigneeForm.get('phoneNumber')?.value"
                      (click)="openCallPanel()"
                      [title]="'call_panel.start_call' | translate"
                    >
                      <i class="icon-telephone"></i>
                    </button>
                  </div>
                </div>
                <div *ngIf="assigneeForm.hasError('invalidPhoneNumber') && assigneeForm.get('phoneNumber')?.touched">
                  <small class="error_validation">Si el prefijo es +34, el número debe tener 9 dígitos.</small>
                </div>

                <div *ngIf="isFieldInvalid('phoneNumber')">
                  <small class="error_validation">El teléfono debe tener 9 dígitos, o si empieza con +34, debe tener 9
                    dígitos adicionales.</small>
                </div>
              </div>
            </div>

            <div class="row linea"></div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <div class="mb-3">
                  <label for="billing_address" class="form-label">{{
                    "inputs.billing_address" | translate
                    }}
                    <span class="required">*</span></label>
                  <input id="billing_address" class="form-control" formControlName="billing_address" placeholder="{{
                                          'inputs.billing_address' | translate
                                        }}" />
                </div>
              </div>
              <div class="col-12 col-xl-6">
                <div class="mb-3">
                  <label for="billing_state" class="form-label">{{
                    "inputs.billing_state" | translate
                    }}<span class="required">*</span></label>
                  <input id="billing_state" class="form-control" formControlName="billing_state" placeholder="{{
                                                          'inputs.billing_state' | translate
                                                        }}" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-5 col-xl-6">
                <div class="mb-3">
                  <label for="name" class="form-label">{{
                    "inputs.billing_postal_code" | translate
                    }}<span class="required">*</span></label>
                  <input id="name" class="form-control" formControlName="billing_postal_code" placeholder="{{
                                          'inputs.billing_postal_code' | translate
                                        }}" />
                </div>
                <div *ngIf="isFieldInvalid('billing_postal_code')">
                  <small class="error_validation">El codigo postal debe tener 4 o 5 números</small>
                </div>
              </div>
              <div class="col-7 col-xl-6">
                <div class="mb-3">
                  <label for="lastname" class="form-label">{{
                    "inputs.billing_city" | translate
                    }}<span class="required">*</span></label>
                  <input id="lastname" class="form-control" formControlName="billing_city" placeholder="{{
                                          'inputs.billing_city' | translate
                                        }}" />
                </div>
              </div>
            </div>

          </div>

          <div class="button-create-container">
            <button type="submit" class="btn btn-primary btn-primary-form create-button" [disabled]="taxIdExists">
              {{ "buttons.create_client" | translate }}
            </button>
          </div>
          <!-- </form> -->
        </div>
      </form>
    </div>

  </div>

</div>
